import styled from '@emotion/styled';

const Badges = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[20]} ${({ theme }) => theme.spacing[40]};
  margin: 0;
  padding: ${({ theme }) => theme.spacing[20]};
  list-style: none;

  ${({ theme }) => theme.mq('xl')} {
    gap: ${({ theme }) => theme.spacing[20]};
  }
`;

const Badge = styled.li`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[20]};
  padding: ${({ theme }) => theme.spacing[20]}
    ${({ theme }) => theme.spacing[40]} ${({ theme }) => theme.spacing[20]}
    ${({ theme }) => theme.spacing[30]};
  border: 1px solid ${({ theme }) => theme.colors.neutral.grey60};
  border-radius: ${({ theme }) => theme.radius.round};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  box-shadow: 0 4px 14px rgb(0 0 0 / 12%);
  color: ${({ theme }) => theme.colors.neutral.grey160};
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: ${({ theme }) => theme.fontSize.xs.size};
  font-weight: 600;
  line-height: 1.43;

  ${({ theme }) => theme.mq('xl')} {
    gap: ${({ theme }) => theme.spacing[10]};
    padding: ${({ theme }) => theme.spacing[10]}
      ${({ theme }) => theme.spacing[40]} ${({ theme }) => theme.spacing[10]}
      ${({ theme }) => theme.spacing[10]};
    font-family: ${({ theme }) => theme.fontFamily.alternate};
    font-size: ${({ theme }) => theme.fontSize.sm.size};
    font-weight: ${({ theme }) => theme.fontWeight.heading};
    line-height: ${({ theme }) => theme.fontSize.sm.lineHeight};
  }
`;

const IconWrapper = styled.span`
  display: inline-flex;
  fill: ${({ theme }) => theme.colors.brand.green120};

  svg {
    width: ${({ theme }) => theme.spacing[50]};
    height: ${({ theme }) => theme.spacing[50]};
  }

  ${({ theme }) => theme.mq('xl')} {
    padding: ${({ theme }) => theme.spacing[20]};
  }
`;

const ShortText = styled.span`
  white-space: nowrap;

  ${({ theme }) => theme.mq('xl')} {
    display: none;
  }
`;

const LongText = styled.span`
  display: none;
  white-space: nowrap;

  ${({ theme }) => theme.mq('xl')} {
    display: inline;
  }
`;

export { Badge, Badges, IconWrapper, LongText, ShortText };
